module.exports = require("mdi-react/AlertOutlineIcon");